import { jsx as _jsx } from "react/jsx-runtime";
// dev/app-skeleton/src/App.tsx
// 顶层只挂 Router + 周期性后台任务。
// D13.6 / F-REV-02 修：原来 purgeExpiredSnapshots 没 schedule，过期快照只会在下次"导入"前清；
//   改为 App mount 时 1) 立即跑一次 2) 每 1h setInterval 跑一次。
// 用 React.StrictMode 在 dev 下会 mount 两次 effect，所以用 module-level guard 防双挂；
// 真正只跑一份 timer，prod 行为也一致。
import { useEffect } from "react";
import { Router } from "./router";
import { purgeExpiredSnapshots } from "./lib/backup";
const PURGE_INTERVAL_MS = 60 * 60 * 1000; // 1h
// module-scope guard：StrictMode 双 mount / fast-refresh / 多 App 渲染都只挂一份 timer。
let purgeTimer = null;
let purgeStarted = false;
function startPurgeLoop() {
    if (purgeStarted)
        return;
    purgeStarted = true;
    // 立即跑一次（不阻塞渲染；失败吞掉，仅控制台告警）
    void purgeExpiredSnapshots().catch((e) => console.warn("[purge] initial run failed:", e));
    purgeTimer = setInterval(() => {
        void purgeExpiredSnapshots().catch((e) => console.warn("[purge] tick failed:", e));
    }, PURGE_INTERVAL_MS);
}
export function App() {
    useEffect(() => {
        startPurgeLoop();
        // 不在 cleanup 里 clearInterval：StrictMode 第二次 mount 会立刻再启一份，反而双跑。
        // App 卸载约等于关页签 → 浏览器自然回收 timer。
        return;
    }, []);
    return _jsx(Router, {});
}
